import React from "react";

export const Calendar = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    width={16}
    height={16}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M19.368 3.316h1.158a2.316 2.316 0 012.316 2.316v15.052A2.316 2.316 0 0120.526 23H4.316A2.316 2.316 0 012 20.684V5.632a2.316 2.316 0 012.316-2.316h1.158V1.579c0-.32.259-.579.579-.579H7.21c.32 0 .578.26.578.579v1.737h9.264V1.579c0-.32.259-.579.579-.579h1.157c.32 0 .58.26.58.579v1.737zM4.316 20.684h16.21V7.947H4.316v12.737z"
      clipRule="evenodd"
    ></path>
  </svg>
);
